module.exports = __webpack_public_path__ + "static/img/hotLdetail.ffacaec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hotpic/hotLdetail.jpg
// module id = 4ACU
// module chunks = 52